// Single source of truth for order status display in Norwegian.
// Internal status keys remain in English for stability; only display
// labels are Norwegian.

export const STATUS_LABEL = {
  assigned: { label: "Betalt", color: "bg-sky-50 text-sky-700" },
  // legacy alias — admin may reassign without changing status
  tildelt: { label: "Tildelt verksted", color: "bg-sky-50 text-sky-700" },
  received: { label: "Enhet mottatt", color: "bg-indigo-50 text-indigo-700" },
  in_progress: { label: "Under reparasjon", color: "bg-indigo-50 text-indigo-700" },
  repair_done: { label: "Fullført", color: "bg-emerald-50 text-emerald-700" },
  sent_back: { label: "Sendt tilbake", color: "bg-emerald-50 text-emerald-700" },
  completed: { label: "Fullført", color: "bg-emerald-100 text-emerald-800" },
  paid_out: { label: "Utbetalt", color: "bg-slate-100 text-slate-700" },
  diagnosis_ready: { label: "Diagnose klar", color: "bg-orange-50 text-orange-700" },
  approved_awaiting_extra_payment: { label: "Godkjent — venter på betaling", color: "bg-amber-50 text-amber-700" },
  declined_returning: { label: "Avslått", color: "bg-slate-100 text-slate-600" },
};

export const labelOf = (status) =>
  STATUS_LABEL[status]?.label || status;

export const colorOf = (status) =>
  STATUS_LABEL[status]?.color || "bg-slate-100 text-slate-600";
